import React, { Fragment, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    EyeInvisibleOutlined,
    CaretRightOutlined,
} from "@ant-design/icons";
import { Card, Input, Collapse, Upload, Image, message, Divider } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Toast } from "bootstrap";
import PageHeader from "../view/pageheader";
import InputComponent from "../fields/InputComponent";
import SelectComponent from "../fields/SelectComponent";
import ButtonComponent from "../fields/ButtonComponent";
import CardComponent from "../fields/CardComponent";
import {
    addMobileClient,
    getMobileClientData,
    updateMobileClient,
    resetSuccessFlag,
} from "../store/reducer/mobileClient";
import ModalComponent from "../fields/ModalComponent";
import { toast } from "react-toastify";
import ManagedProject from "./Projects/ManagedProject";
import Projects from "./Projects/projects";
import CardOrCollapse from "../fields/CardOrCollapse";
import { getProjectList } from "../store/reducer/projectSlice";
import { getStatesList } from '../store/reducer/statesListSlice';
import { assestURL } from '../services/config';

const AddEditMobileClient = () => {
    const { Panel } = Collapse;
    const [clientDetails, setClientDetails] = useState({
        image: '',
        mobile_client_number: "",
        email: "",
        password: "",
        confirm_password: "",
        address_one: "",
        address_two: "",
        mobile: "",
        city: "",
        state: "",
        zip_code: "",
        client_status: 1,
        first_name: '',
        last_name: ''
    });

    const [status, setStatus] = useState([
        {
            value: 1,
            label: "Active",
        },
        {
            value: 0,
            label: "Inactive",
        },
    ]);
    const [touchedFields, setTouchedFields] = useState({});
    const [, forceUpdate] = useState(); // Use state to trigger re-renders
    const [type, setType] = useState("add");
    const [stateList, setStateList] = useState([]);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { client_id } = useParams();
    const roleID = localStorage.getItem('role_id')
    const category_type = localStorage.getItem('category_type')
    const [previewOpen, setPreviewOpen] = useState(false);
    const [isEditPage, setisEditPage] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [fileListOnChange, setFileListOnChange] = useState([]);
    console.log(clientDetails, "clientDetails=");

    console.log(clientDetails.mobile_client_number, client_id, "mobileee");
    //Selectors
    const {
        addClientLoading,
        addClientError,
        addedStaff,
        addClientSuccess,
        updateClientSuccess,
        getAddedData,
        clientError,
    } = useSelector(state => state.mobileClient);
    const {
        projectListData
    } = useSelector(state => state.project);
    console.log(getAddedData, "getAddedData");

    const { statesListData, statesListLoading, statesError, statesErrorMessage } = useSelector((state) => state.states);

    const validator = useRef(
        new SimpleReactValidator({
            className: "validation-message",
            messages: {
                required: "Please enter :attribute",
                email: "Email should contain @ and .",
                alpha: ":attribute should contain only alphabets",
                regex: ":attribute format is invalid",
                in: "Confirm password does not match with password field",
                min: ":attribute must be at least :min characters",
                confirmed: "Passwords do not match",
                strong_password:
                    "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character",
                no_spaces: "Spaces are not allowed in the :attribute.",
            },
            validators: {
                strong_password: {
                    // name the validator
                    message:
                        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character",
                    rule: (val, params, validator) => {
                        return (
                            validator.helpers.testRegex(
                                val,
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
                            ) && params.indexOf(val) === -1
                        );
                    },
                    // required: true, // This is an optional parameter. If true, the field will be required.
                },
                no_spaces: {
                    message: "Spaces are not allowed in the :attribute.",
                    rule: val => !/\s/.test(val), // Checks for spaces
                },
            }
        })
    );

    const validationRules = {
        client_number: `required`,
        email: `required|email`,
        address_one: `required`,
        address_two: "",
        password: !isEditPage ? `required|strong_password` : `strong_password`,
        confirm_password: !isEditPage
            ? `required|in:${clientDetails.password}`
            : `in:${clientDetails.password}`,
        mobile: `required|mobile`,
        city: `required`,
        state: `required`,
        zip_code: `required|numeric|min:5|max:12`,
        client_status: `required`,
        first_name: "",
        last_name: "",
    };

    const formatPhoneNumber = (value) => {
        // Remove all non-digit characters
        const cleaned = ('' + value).replace(/\D/g, '');

        // Check if the input is longer than 10 characters
        if (cleaned.length <= 10) {
            const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
            if (match) {
                return [match[1], match[2], match[3]].filter(Boolean).join('-');
            }
        }
        return value; // Return unformatted value if it's too long
    };

    const addEditUserDetails = (e) => {
        const { name, value } = e.target;

        // If the input is for the mobile field, format it
        const formattedValue = name === "mobile" ? formatPhoneNumber(value) : value;

        setClientDetails({
            ...clientDetails,
            [name]: formattedValue
        });
        setTouchedFields(prevState => ({
            ...prevState,
            [name]: true,
        }));
    };

    const handleSubmit = e => {
        e.preventDefault();
        if (validator.current.allValid()) {
            let postData = clientDetails;
            console.log(postData, "postt");
            postData.image = fileListOnChange?.length ? fileListOnChange[0]?.originFileObj : clientDetails.image;
            if (type === "add") {
                dispatch(addMobileClient({ postData }));
            } else {
                let updateID = atob(client_id);
                console.log(updateID, "updateID");
                dispatch(updateMobileClient({ postData, updateID }));
            }
        } else {
            validator.current.showMessages();
            forceUpdate(1);
        }
    };

    const reset = () => {
        setClientDetails({
            ...clientDetails,
            mobile_client_number: "",
            email: "",
            password: "",
            confirm_password: "",
            address_one: "",
            address_two: "",
            image: "",
            mobile: "",
            city: "",
            state: "",
            zip_code: "",
            client_status: 1,
        });
        setTouchedFields({});
    };

    const onChange = (value, name) => {
        console.log(value, name, "dataaa==");
        setClientDetails(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const onSearch = value => {
        console.log("search:", value);
    };

    function getData(data) {
        const payload = { ...data, id: atob(client_id), type: 'mobile' };
        console.log("payload", payload);
        dispatch(getProjectList(payload));
    }

    //Image Onchange and Preview functions

    const handlePreview = async (file) => {
        let preview = file.url;

        if (!preview && file.originFileObj) {
            preview = URL.createObjectURL(file.originFileObj);
        }

        setPreviewImage(preview);
        setPreviewOpen(true);
    };

    const handleChange = ({ fileList: newFileList }) => {
        setFileListOnChange(newFileList)
        setFileList(newFileList)
    };

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            {/* <PlusOutlined /><br /> */}
            <strong
                style={{
                    marginTop: 8,
                }}
            >
                Upload Profile Image
            </strong>
        </button >
    );

    useEffect(() => {
        if (clientDetails.image && isEditPage) {
            const imageSrc = `${assestURL}${clientDetails.image}`;
            console.log(imageSrc, 'imageSrc==');
            setFileList([{ uid: '-1', name: 'image.png', status: 'done', url: imageSrc }]);
        }
    }, [clientDetails]);

    useEffect(() => {
        if (addClientSuccess) {
            setClientDetails({
                ...clientDetails,
                mobile_client_number: "",
                email: "",
                password: '',
                confirm_password: '',
                address_one: "",
                address_two: "",
                image: "",
                mobile: "",
                city: "",
                state: "",
                zip_code: "",
                client_status: 1,
            });
            toast.success("Client added Successfully!");
            dispatch(resetSuccessFlag({ flag: "addClientSuccess" }));
            navigate("/mobile-clients");
        }
        if (updateClientSuccess) {
            // setClientDetails({
            //    ...clientDetails,
            //    client_number: "",
            //    email: "",
            //    address_one: "",
            //    address_two: "",
            //    mobile: "",
            //    city: "",
            //    state: "",
            //    zip_code: "",
            //    client_status: 1,
            // });
            toast.success("Client Updated Successfully!");
            dispatch(resetSuccessFlag({ flag: "updateClientSuccess" }));
            // navigate("/clients");
        }
        if (clientError) {
            toast.error(clientError);
        }
    }, [addClientSuccess, updateClientSuccess, clientError, dispatch, navigate]);

    console.log(addClientSuccess, updateClientSuccess, "updateClientSuccess");

    useEffect(() => {
        if (client_id) {
            getData();
            setType("edit");
            setisEditPage(true);
            const decodedId = atob(client_id); // Use a different variable name
            dispatch(getMobileClientData({ id: decodedId }));
        } else {
            setisEditPage(false);
            setType("add");
            setTouchedFields({});
        }
    }, [client_id, dispatch]);

    useEffect(() => {
        dispatch(getStatesList({}));
    }, [])

    useEffect(() => {
        if (getAddedData && type === "edit") {
            setClientDetails({
                ...clientDetails,
                first_name: getAddedData?.first_name,
                last_name: getAddedData?.last_name,
                mobile_client_number: getAddedData?.mobile_client_number,
                email: getAddedData?.email,
                image: getAddedData?.image,
                password: '',
                confirm_password: '',
                address_one: getAddedData?.address_one,
                address_two: getAddedData?.address_two,
                mobile: getAddedData?.mobile,
                city: getAddedData?.city,
                state: getAddedData?.state,
                zip_code: getAddedData?.zip_code,
                client_status: getAddedData?.client_status,
            });
        }
    }, [getAddedData, type]);

    useEffect(() => {
        if (statesListData.length) {
            const list = statesListData.map(item => ({
                value: item.state,
                label: item.state,
            }));
            setStateList([...list]);
        }
    }, [statesListData])

    console.log(clientDetails, "clientDetails");

    return (
        <div className="container-fluid-staff">
            <PageHeader
                HeaderText={type === "add" ? "Add Mobile Client" : "Update Mobile Client"}
                Breadcrumb={[{ name: type === "add" ? "Add Mobile Client" : "Update Mobile Client" }]}
                backButtonUrl={`/mobile-clients`}
            />
            <CardOrCollapse type={type} titleName="Mobile Client Details">
                <div class="grid-container">
                    <div className="grid-item col-span-1">
                        <label htmlFor="first_name">First Name</label>
                        {/* <span className="m-1" style={{ color: "red" }}>
                        *
                     </span> */}
                        <InputComponent
                            name="first_name"
                            placeholder="First Name"
                            type="text"
                            icon={<UserOutlined />}
                            value={clientDetails.first_name}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="first_name">Last Name</label>
                        {/* <span className="m-1" style={{ color: "red" }}>
                        *
                     </span> */}
                        <InputComponent
                            name="last_name"
                            placeholder="Last Name"
                            type="text"
                            icon={<UserOutlined />}
                            value={clientDetails.last_name}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div class="grid-item start-col-3 row-span-2">
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Upload
                                className='photographer'
                                listType="picture-card"
                                fileList={fileList}
                                onPreview={handlePreview}
                                onChange={handleChange}
                                maxCount={1}
                                action="https://yourserver.com/upload"  // Replace with your actual upload URL
                                onRemove={(file) => {
                                    // Optionally, handle image removal logic
                                    message.success('Image removed');
                                    setClientDetails({
                                        ...clientDetails,
                                        image: ""
                                    })
                                }}
                            >
                                {fileList.length >= 1 ? null : uploadButton}
                            </Upload>
                            {previewImage && (
                                <Image
                                    style={{
                                        display: 'none',
                                        height: '150px',
                                        width: '150px'
                                    }}
                                    preview={{
                                        visible: previewOpen,
                                        onVisibleChange: (visible) => setPreviewOpen(visible),
                                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                    }}
                                    src={previewImage}
                                />
                            )}
                        </div>
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="email">Email</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <InputComponent
                            name="email"
                            placeholder="Email Id"
                            type="text"
                            icon={<MailOutlined />}
                            value={clientDetails.email}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="mobile">Phone</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <InputComponent
                            name="mobile"
                            placeholder="xxx-xxx-xxxx"
                            type="text"
                            value={clientDetails.mobile}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="password">Password</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <Input.Password
                            autoComplete="new-password"
                            //   type={type}
                            placeholder={"Enter password"}
                            name={"password"}
                            style={{
                                padding: "5px",
                            }}
                            value={clientDetails.password}
                            onChange={addEditUserDetails}
                            suffix={<EyeInvisibleOutlined />}
                        />
                        {validationRules["password"] && (
                            <div style={{ color: "red" }}>
                                {validator.current.message(
                                    "password",
                                    clientDetails.password,
                                    validationRules["password"]
                                )}
                            </div>
                        )}
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="confirm_password">Confirm Password</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <Input.Password
                            autoComplete="new-password"
                            placeholder={"Confirm Password"}
                            name={"confirm_password"}
                            style={{
                                padding: "5px",
                            }}
                            value={clientDetails.confirm_password}
                            onChange={addEditUserDetails}
                            suffix={<EyeInvisibleOutlined />}
                        />
                        {validationRules["confirm_password"] && (
                            <div style={{ color: "red" }}>
                                {validator.current.message(
                                    "confirm_password",
                                    clientDetails.confirm_password,
                                    validationRules["confirm_password"]
                                )}
                            </div>
                        )}
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="address_one">Address (House No, Building, Street, Area)</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <InputComponent
                            name="address_one"
                            placeholder="Address line 1"
                            type="text"
                            icon={<i className="bi bi-geo-alt-fill"></i>}
                            value={clientDetails.address_one}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="city">City</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <InputComponent
                            name="city"
                            placeholder="City"
                            type="text"
                            icon={<i className="bi bi-geo-alt-fill"></i>}
                            value={clientDetails.city}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="state">State</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <SelectComponent
                            name="state"
                            value={clientDetails.state ? clientDetails.state : null}
                            placeholder="Select State"
                            onChange={value => onChange(value, "state")}
                            onSearch={onSearch}
                            options={stateList}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="zip_code">Zip Code</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <InputComponent
                            name="zip_code"
                            placeholder="Zip Code"
                            type="text"
                            icon={<i className="bi bi-geo-alt-fill"></i>}
                            value={clientDetails.zip_code}
                            onChange={addEditUserDetails}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                    <div className="grid-item col-span-1">
                        <label htmlFor="name">Mobile Client Status</label>
                        <span className="m-1" style={{ color: "red" }}>
                            *
                        </span>
                        <br />
                        <SelectComponent
                            name="client_status"
                            value={clientDetails.client_status}
                            placeholder="Please choose staff category_type"
                            onChange={value => onChange(value, "client_status")}
                            onSearch={onSearch}
                            options={status}
                            validator={validator}
                            touchedFields={touchedFields}
                            validationRules={validationRules}
                        />
                    </div>
                </div >
                {
                    roleID === '2' && category_type === '3' ? null :
                        <div className="text-center mt-3">
                            <ButtonComponent
                                style={{ backgroundColor: "#f7931e", color: "white" }}
                                onClick={handleSubmit}
                                buttonName={type === "add" ? "Add Mobile Client" : "Update Mobile Client"}
                                icon={<i class="fa fa-user-plus" aria-hidden="true"></i>}
                            />
                            &nbsp;
                            <ButtonComponent
                                style={{ backgroundColor: "#6E6E6E", color: "white" }}
                                onClick={reset}
                                buttonName="Reset"
                                icon={<i class="fa fa-refresh" aria-hidden="true"></i>}
                            />
                        </div>
                }
            </CardOrCollapse >
            {/* </Panel>
         </Collapse> */}
            < br />
            {type === "edit" ? (
                <Projects clientNumber={clientDetails?.mobile_client_number} client_id={atob(client_id)} is_mobile={true} />
            ) : null}
            {/* {type === 'edit' ?
                
                <ManagedProject />
                : null} */}
            {/* </Card> */}
        </div >
    );
};

export default AddEditMobileClient;
